import {all} from 'redux-saga/effects';
import {signIn} from '@/auth/sagas/signInSaga.js';
import {settingSaga} from '@/app/sagas/minervaSettingsSaga.js';
import {planningReportSaga} from '@/reports/sagas/planningReportSaga.js';
import {catalogSaga} from '@/catalog/sagas/catalogSaga.js';
import {reportSaga} from '@/reports/sagas/reportSaga.js';
import {adminCatalogSaga} from '@/catalog/sagas/adminCatalogSaga.js';
import {assignmentCatalogSaga} from '@/catalog/sagas/assignmentCatalogSaga.js';
import {skillsTargetIdMapSaga} from '@/skills/sagas/skillsTargetIdMapSaga.js';

function* rootSaga() {
    yield all([
        signIn(),
        settingSaga(),
        catalogSaga(),
        planningReportSaga(),
        reportSaga(),
        adminCatalogSaga(),
        assignmentCatalogSaga(),
        skillsTargetIdMapSaga(),
    ]);
}

export default rootSaga;
